import NTFSInputField from "./NTFSInputField";
import { SET_MAX_CPU_CAPACITY } from "../dataSourceConstants";

function NTFSCPULimit(props) {
  const { ntfsCpuLimit } = props;

  return (
    <NTFSInputField
      {...props}
      label="Max CPU Capacity"
      value={ntfsCpuLimit}
      placeholder="Max CPU Capacity"
      actionType={SET_MAX_CPU_CAPACITY}
      errorKey="ntfsMaxCpu"
    />
  );
}

export default NTFSCPULimit;
